import { Form, Select, SelectProps } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const ValidityMonths = (props: SelectProps) => {
  const { t } = useTranslation()
  const insuredDays = Form.useWatch('days') || 0

  const months = Array.from({ length: 11 }, (_, i) => ({
    label: t('months_count', { count: i + 2 }),
    value: i + 2
  })).filter((item) => Number(item.value) * 30 >= insuredDays)

  useEffect(() => {
    if (insuredDays / 30 > Number(props.value)) props.onChange?.(null)
  }, [insuredDays, props.value])

  return <Select options={months} {...props} />
}
